export default __webpack_public_path__ + "static/media/1.737a374b.png";